module.exports = __webpack_public_path__ + "img/star4.e66bdaf6.png";